/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Paid_Free_BInputs */



/**
* | output |
* | --- |
* | "Players still carry a payment status. On a free event, ignore it." |
*
* @param {Tournament_Wiz_Tip_Paid_Free_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_paid_free_b = /** @type {((inputs?: Tournament_Wiz_Tip_Paid_Free_BInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Paid_Free_BInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les joueurs portent quand même un statut de paiement. Sur un événement gratuit, ignorez-le.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los jugadores siguen llevando un estado de pago. En un evento gratuito, ignórelo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os jogadores ainda carregam um status de pagamento. Num evento gratuito, ignore.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I giocatori portano comunque uno stato di pagamento. In un evento gratuito, ignoralo.")
	return /** @type {LocalizedString} */ ("Players still carry a payment status. On a free event, ignore it.")
});